import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Carousel.css";

const reviews = ["/R1.png", "/R2.png", "/R3.png"];

const SwiperComponent = () => (
  <Swiper
    className="carousel carousel-narrow"
    modules={[Navigation, Pagination]}
    navigation
    pagination={{ clickable: true }}
    spaceBetween={140}
    slidesPerView={1}
  >
    {reviews.map((src, index) => (
      <SwiperSlide key={src}>
        <img
          className="review-image"
          src={src}
          alt={`Customer review ${index + 1}`}
          loading="lazy"
        />
      </SwiperSlide>
    ))}
  </Swiper>
);

export default SwiperComponent;
